import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/globals/Sidebar";
import SidebarToggler from "../components/globals/SidebarToggler";
import { useState } from "react";
import { commonLinks, userLinks } from "../sidebarLinks";
import PlaceUserOptions from "../components/specials/PlaceUserOptions";
import { FullScreenView } from "../components/specials/FullScreenView";
import { useUserHomeHooks } from "../hooks/useUserHomeHooks";

const UserLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { pathname } = useLocation();
  const {}=useUserHomeHooks();

  return (
    <div className="full-screen d-flex overflow-hidden">
      <Sidebar
        isOpen={sidebarOpen}
        onLogoutClick={onLogout}
        setIsOpen={setSidebarOpen}
        links={userLinks} //give the admin links and so on for user layout write user links in sidebarLinks.js and import here
      />
      <div className="main-screen">
        <SidebarToggler
          iconColor={"black"}
          isOpen={sidebarOpen}
          responsiveClassName={"sidebar-toggler"}
          setisOpen={setSidebarOpen}
        />

        <div>
          <FullScreenView />
          <Outlet />
          {pathname?.includes("places") && <PlaceUserOptions />}
        </div>
      </div>
    </div>
  );
};

export default UserLayout;
